import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  addNewStockSales,
  addSalesOfficeOutWardStocks,
  getCategories,
  getPartyApi,
  getUnitAPI,
  getUserApi,
  getUserByRoleId,
  updateStockInward,
} from "api";

class RecieveExternalJangad extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      partyList: [],
      factoryList: [],
      categoryList: [],
      deliveryBoyList: [],
      jangadId: "",
      factoryId:
        "query" in props?.location
          ? props?.location?.query?.data?.factoryId
          : "",
      categoryId:
        "query" in props?.location
          ? props?.location?.query?.data?.mainJangad.categoryId
          : "",
      partyJangadNo: props?.location?.query ? props?.location?.query?.data?.mainJangad.partyJangadNo : "",
      partyId:
        "query" in props?.location ? props?.location?.query?.data?.partyId : "",
      props: props?.location?.query
        ? props.location.query
        : { isEdit: 1, data: null },
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async handleSubmit(values) {
    console.log(values);
    if (this.state.props.isEdit == 1) {
      delete values.jangadId;
      values.weightType = "CT";
      let temp = {
        partyId: values.partyId,
        categoryId: this.state.categoryId,
        partyJangadNo: values.partyJangadNo,
        jangads: [
          {
            userId: values.userId,
            fromDeliverBoyId: values.fromDeliverBoyId,
            toDeliverBoyId: values.toDeliverBoyId,
            factoryId: values.factoryId,
            weightType: values.weightType,
            remarks: values.remarks,
            nextRemarks: values.nextRemarks,
            weight: values.weight,
            cycle: values.cycle,
            pieces: values.pieces,
          },
        ],
      };
      console.log(temp);
      const data = await addNewStockSales(temp);
      this.setState({
        jangadId: data.data.id,
      });
   
    } else if(this.state.props.isEdit == 4){
      let temp = {
        id: this.state.props.data.mainJangadId,
        partyId: values.partyId,
        categoryId: parseInt(this.state.categoryId),
        partyJangadNo: values.partyJangadNo,
        jangads: [
          {
            id: this.state.props.data.id,
            userId: values.userId,
            fromDeliverBoyId: values.fromDeliverBoyId,
            factoryId: values.factoryId,
            weightType: values.weightType,
            remarks: values.remarks,
            nextRemarks: values.nextRemarks,
            weight: values.weight,
            cycle: values.cycle,
            pieces: values.pieces,
          },
        ],
      };
      const data = await updateStockInward(temp);
    } else {
      let temp = {
        
        mainJangadId: this.state.props.data.mainJangadId,
        jangadId: this.state.props.data.id,
      };
      console.log(temp)
      const data = await addSalesOfficeOutWardStocks(temp);
      // this.state.history.goBack();
    }
  }

  async componentDidMount() {
    const categories = await getCategories();
    const party = await getPartyApi({page:null,limit:null,name:null,partyCode:null});
    const factory = await getUnitAPI({ isInternal: null });
    this.setState({
      partyList: party.data.parties,
      factoryList: factory.data.factories,
      categoryList: categories.data,
    });
    // if (this.state.props.isEdit == 2) {
    this.getDeliveryBoy();
    // }
  }
  async getDeliveryBoy() {
    const deliveryBoy = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000006",
    });
    this.setState({
      deliveryBoyList: deliveryBoy.data.users,
    });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "sales-office";
    const { history } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("External Jangad")}`}
            />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.state.props.isEdit || this.state.props.isView
                            ? this.state.props.isEdit
                              ? `${this.props.t("External Jangad")}`
                              : `${this.props.t("External Jangad")}`
                            : `${this.props.t("External Jangad")}`}
                        </h4>
                      </div>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.props.isEdit == 1
                          ? {
                              jangadId: this.state.jangadId,
                              name: this.state.jangadId,
                              partyJangadNo: this.state.partyJangadNo,
                              partyId: this.state.partyId,
                              categoryId:
                                (this.state && this.state.categoryId) || "",
                              factoryId: this.state.factoryId,
                              weight: (this.state && this.state.weight) || "",
                              pieces: (this.state && this.state.pieces) || "",
                              fromDeliverBoyId:
                                (this.state && this.state.fromDeliverBoyId) ||
                                "",
                              cycle: (this.state && this.state.cycle) || 1,
                              remarks: (this.state && this.state.remarks) || "",
                              nextRemarks:
                                (this.state && this.state.nextRemarks) || "",
                            }
                          : {
                              jangadId: this.state.props.data.mainJangadId,
                              name: this.state.props.data.mainJangad.name,

                              partyJangadNo:
                                this.state.props.data.mainJangad.partyJangadNo,
                              partyId: this.state.props.data.mainJangad.partyId,
                              categoryId:
                                this.state.props.data.mainJangad.categoryId,
                              factoryId: this.state.props.data.factoryId,
                              weight: this.state.props.data.weight,
                              pieces: this.state.props.data.pieces,
                              fromDeliverBoyId:
                                this.state.props.data.fromDeliverBoyId,
                              cycle: (this.state && this.state.cycle) || 1,
                              remarks: this.state.props.data.remarks,
                              nextRemarks:
                                (this.state &&
                                  this.state.props.data.nextRemarks) ||
                                "",
                            }
                      }
                      validationSchema={Yup.object().shape({
                        jangadId: Yup.string().notRequired(),
                        partyJangadNo: Yup.string().required(
                          "This Value is Required"
                        ),
                        partyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        factoryId: Yup.string().required(
                          "This Value is Required"
                        ),
                        categoryId: Yup.string().required(
                          "This Value is Required"
                        ),
                        weight: Yup.number()
                          .min(1)
                          .max(9223372036854775807)
                          .required("This Value is Required"),
                        pieces: Yup.number()
                          .min(1)
                          .max(2147483647)
                          .required("This Value is Required"),
                        fromDeliverBoyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        cycle: Yup.number().required("This Value is Required"),
                        remarks: Yup.string().max(512)
                          .min(0)
                          .max(255)
                          .nullable()
                          .notRequired(),
                        nextremarks: Yup.string().max(512)
                          .min(0)
                          .max(255)
                          .nullable()
                          .notRequired(),
                      })}
                      onSubmit={async values => {}}
                    >
                      {({ errors, status, touched, values, validateForm }) => (
                        <Form className="needs-validation">
                          <Row>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="jangadId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad Id")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.jangadId && touched.jangadId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  type="text"
                                  name="jangadId"
                                  placeholder="JANGAD0000123"
                                />
                                <ErrorMessage
                                  name="jangadId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad Id")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  type="text"
                                  name="name"
                                  placeholder="JANGAD0000123"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.partyId && touched.partyId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.partyId}
                                  onChange={e => {
                                    this.setState({
                                      partyId: e.target.value,
                                    });
                                  }}
                                  name="partyId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>

                                  {this.state.partyList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="partyId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyJangadNo"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Jangad No")}.
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyJangadNo &&
                                    touched.partyJangadNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyJangadNo"
                                  placeholder="Enter jangad No."
                                  value={this.state.partyJangadNo}
                                  onChange={e => {
                                    this.setState({
                                      partyJangadNo: e.target.value,
                                    });
                                  }}
                                />
                                <ErrorMessage
                                  name="partyJangadNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="categoryId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Diamond Category")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.categoryId && touched.categoryId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="categoryId"
                                  as="select"
                                  value={this.state.categoryId}
                                  onChange={e => {
                                    this.setState({
                                      categoryId: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="" disabled>Select categories</option>
                                  {this.state.categoryList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="factoryId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Unit Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.factoryId && touched.factoryId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="factoryId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                  value={this.state.factoryId}
                                  onChange={e => {
                                    this.setState(
                                      {
                                        factoryId: e.target.value,
                                      },
                                      () => this.getDeliveryBoy()
                                    );
                                  }}
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.factoryList?.map(x => (
                                    <option value={x.id} key={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="factoryId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="pieces"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total No of pieces")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.pieces && touched.pieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="pieces"
                                  placeholder="No. of peices"
                                  readOnly={
                                    this.state.props.data?.dataEntryStatus ==
                                    "A"
                                      ? true
                                      : false
                                  }
                                />
                                <ErrorMessage
                                  name="pieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total Weight")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="weight"
                                  placeholder="20.25 CT"
                                  readOnly={
                                    this.state.props.data?.dataEntryStatus ==
                                    "A"
                                      ? true
                                      : false
                                  }
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                           
                            <div className="mb-3 row">
                              <Label
                                htmlFor="fromDeliverBoyId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Delivery Boy Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.fromDeliverBoyId &&
                                    touched.fromDeliverBoyId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="fromDeliverBoyId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.deliveryBoyList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="fromDeliverBoyId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cycle"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Cycle")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cycle && touched.cycle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="cycle"
                                  readOnly={true}
                                  placeholder="1"
                                />
                                <ErrorMessage
                                  name="cycle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="remarks"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Self Internal Remarks")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.remarks && touched.remarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="remarks"
                                  as="textarea"
                                  rows="5"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="nextRemarks"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Data Entry Person Remarks")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.nextRemarks && touched.nextRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="nextRemarks"
                                  as="textarea"
                                  rows="5"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="nextRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {this.state.props.isEdit == 1 && (
                              <>
                                <div className="col-md-12 text-end">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="fs-4 px-5"
                                    onClick={() => {
                                      validateForm()
                                        .then(data => {
                                          if (Object.keys(data).length == 0) {
                                            this.handleSubmit(values);
                                          }
                                        })
                                        .catch(err => console.log(err));
                                    }}
                                  >
                                    Receive
                                  </Button>
                                </div>
                              </>
                            )}
                            {this.state.props.isEdit == 2 && (
                              <>
                                <div className="col-md-12 text-end">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="fs-4 px-5"
                                    onClick={() => {
                                      validateForm()
                                        .then(data => {
                                          if (Object.keys(data).length == 0) {
                                            this.handleSubmit(values);
                                          }
                                        })
                                        .catch(err => console.log(err));
                                    }}
                                  >
                                    Receive
                                  </Button>
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="fs-4 px-5 ms-3"
                                    onClick={() => {
                                      this.state.history.goBack();
                                    }}
                                  >
                                    Back
                                  </Button>
                                </div>
                              </>
                            )}
                            {this.state.props.isEdit == 3 && (
                              <div className="col-md-12 text-end">
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="fs-4 px-5 ms-3"
                                  onClick={() => {
                                    this.state.history.goBack();
                                  }}
                                >
                                  Back
                                </Button>
                              </div>
                            )}
                            {this.state.props.isEdit == 4 && (
                              <>
                                <div className="col-md-12 text-end">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="fs-4 px-5"
                                    onClick={() => {
                                      validateForm()
                                        .then(data => {
                                          if (Object.keys(data).length == 0) {
                                            this.handleSubmit(values);
                                          }
                                        })
                                        .catch(err => console.log(err));
                                    }}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="fs-4 px-5 ms-3"
                                    onClick={() => {
                                      this.state.history.goBack();
                                    }}
                                  >
                                    Back
                                  </Button>
                                </div>
                              </>
                            )}
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(RecieveExternalJangad);
